import styled from 'styled-components';
import { Theme } from '@/theme';

export const PopupContent = styled.div`
  background: ${Theme.color.white};
  position: relative;
  width: 100%;
`;

export const Triangle = styled.div`
  position: absolute;
  top: -40px;
  left: 31%;
  transform: translateX(-50%);
  width: 20px;
  height: 17px;
  background: ${Theme.color.white};
  clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
`;

export const Title = styled.h1`
  font-family: ${Theme.font.family.speedeeCondensed};
  font-size: ${Theme.rems(20)};
  line-height: ${Theme.rems(17)};
  font-weight: ${Theme.font.weight.bold};
  margin-bottom: 16px;
  text-transform: uppercase;
`;

export const Description = styled.p`
  font-family: ${Theme.font.family.speedee};
  font-size: ${Theme.rems(16)};
  line-height: 1.2;
  margin-bottom: ${Theme.rems(24)};
`;

export const Button = styled.button`
  background: none;
  border: none;
  font-size: ${Theme.rems(18)};
  color: ${Theme.color.darkGrey};
  font-weight: ${Theme.font.weight.regular};
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  margin-left: auto;
  display: block;
`;